import { Helmet } from "react-helmet-async";

const SITE_NAME = "Choose My Hotel";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.choose-my-hotel.com";
const DEFAULT_DESC = "The independent buyer's guide to US hotels — compare rates across Booking.com, Hotels.com, Marriott, Hilton, Choice, IHG, Hyatt and Wyndham.";
const DEFAULT_IMG = "https://static.prod-images.emergentagent.com/jobs/720f84dd-6507-4ea6-ad34-7d6add44641a/images/bfdf52843290d4b8203e720ca782ce6c16acc3f920976744ddce107179a7d3f8.png";

export default function SEO({ title, description, image, type = "website", path, article }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Compare US hotels across every major operator`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;
  const canonicalPath = path || (typeof window !== "undefined" ? window.location.pathname : "/");
  const url = `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {article && <meta property="article:author" content={article.author} />}
      {article && <meta property="article:section" content={article.category} />}
      {article && <meta property="article:published_time" content={article.published_at} />}
    </Helmet>
  );
}
